/* eslint-disable no-param-reassign */
import axios from 'axios';
import Config from '../config/config';

const defineEnv = Config;
const axiosInstance = axios.create({
  baseURL: defineEnv.api_services.BASE_URL,
  headers: { 'X-FLPMX-Auth-Token': defineEnv.api_services.token },
});

export default axiosInstance;
